<template>
  <div class="ma-6">
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-row>
    <v-col cols="12" lg="8" md="8">
      <div class="borderkotak">
        <div class="heading pa-4"> Pilih Metode Pembayaran</div>
        <v-col cols="12" lg="6" md="12">
          <div class="ma-4">
            <v-radio-group v-model="methode">
              <v-radio class="borderkotak bulat pl-4"
                       v-for="(n, index) in paymentmethod"
                       :key="index"
                       @change="hitungtotal(n)"
                       :label="`${n.name}`"
                       :value="n">
                <template v-slot:label>
                  <div class="mr-2 ml-2 mt-1 mb-1 row">
                    <v-col cols="12" lg="2" md="3" sm="3">
                      <div class="mt-2"><img width="40px" alt="logobank" :src="n.logo"></div>
                    </v-col>
                    <v-col cols="12" lg="10" md="9" sm="9">
                      <div class="ma-0">
                        <div><strong class="success--text">{{n.name}}</strong></div>
                        <div>{{n.description}}</div>
                      </div>
                    </v-col>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </v-col>
      </div>
    </v-col>
    <v-col cols="12" lg="4" md="4">
      <div class="borderkotak boxringkasanbayar">
        <div class="heading pa-4">Ringkasan Deposit Saldo</div>
        <v-divider/>
        <div class="pa-4">
          <v-container>
            <div class="pull-left">Methode Pembayaran</div>
            <div class="pull-right bolt">{{methode.name}}</div>
          </v-container>
          <v-container>
            <div class="pull-left">Nominal Deposit</div>
            <div class="pull-right bolt">{{formatAngka(jmltopup)}}</div>
          </v-container>
          <v-container class="mb-2">
              <div class="pull-left">Biaya</div>
              <div class="pull-right bolt">{{formatAngka(biaya)}}</div>
          </v-container>
          <v-container class="mb-4">
            <v-divider/>
            <div class="pull-left mt-2">Total Bayar</div>
            <div class="pull-right mt-2">{{formatAngka(totalbayar)}}</div>
          </v-container>
        </div>
        <v-divider/>
        <div class="pa-4 panel-syarat">
          <p class="title-deposit-tos">Syarat dan ketentuan deposit</p>
          <ul class="ul-syarat">
            <li>Nominal Deposit yang dimasukkan sudah sesuai dan benar</li>
            <li>Pengguna menjamin transaksi yang dilakukan di IRS Market adalah transaksi produk digital yang legal dan sah menurut undang-undang dan ketentuan hukum yang berlaku di Negara Republik Indonesia</li>
            <li>Pengguna menjamin uang atau dana yang di depositkan bersumber dan atau diperoleh dari suatu perbuatan yang tidak terlarang termasuk namun tidak terbatas pada Tindak Pidana Pencucian Uang (TPPU)</li>
            <li>Pengguna menjamin apabila dikemudian hari ditemukan sumber uang yang didepositkan ini ternyata bersumber dari perbuatan yang dilarang oleh undang-undang dan ketentuan hukum Negara Republik Indonesia maka, Pengguna wajib membebaskan IRS Market dari segala bentuk tuntutan hukum baik Pidana maupun Perdata serta hukum lainnya.</li>
            <li>Pengguna bersedia mengganti segala bentuk kerugian yang timbul dan dialami oleh pihak IRS Market akibat ketidaksesuaian asal usul sumber dana deposit dan transaksi produk digital yang tidak legal atau sah menurut undang-undang dan ketentuan hukum yang berlaku di Negara Republik Indonesia.</li>
            <li>Pengguna dengan penuh kesadaran dan tanggung jawab bersedia menjadi saksi yang meringankan guna membebaskan IRS Market dari segala bentuk tuntutan hukum atas ketidaksesuaian sumber dana deposit yang dilakukan.</li>
            <li>Dengan mencentang atau mengklik tombol setuju pada kolom Deposit dibawah ini maka Pengguna telah memahami dan  menyetujui Syarat Deposit ini</li>
            </ul>
        </div>
        <div class="panel-syarat-bottom ml-4">
            <v-checkbox
            label="Saya setuju dengan syarat dan ketentuan diatas"
            v-model="checkbox"
            :rules="[(v) => !!v || 'You must agree to continue!']"
            required
            >
            </v-checkbox>
          </div>
        <div class="pa-4"><v-btn @click="doTiketDeposit" elevation="0" class="primary" block>Lanjut</v-btn></div>
      </div>
    </v-col>
    </v-row>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TambahSaldo',
  data: () => ({
    methode: 'BCA',
    biaya: 0,
    totalbayar: 0,
    settings: [],
    checkbox: false,
    methodebayar: [
      {
        id: 1,
        nama: 'BCA',
        keterangan: 'Bank Central Asia',
        logo: 'https://icon.irmastore.id/logobca.png',
        tipe: 0
      },
      {
        id: 2,
        nama: 'MANDIRI',
        keterangan: 'Bank Mandiri',
        logo: 'https://icon.irmastore.id/mandiri.png',
        tipe: 0
      },
      {
        id: 1,
        nama: 'BRI',
        keterangan: 'Bank Rakyat Indonesia',
        logo: 'https://icon.irmastore.id/logobri.png',
        tipe: 0
      },
      {
        id: 1,
        nama: 'VA-BRI',
        keterangan: 'Bank Rakyat Indonesia',
        logo: 'https://icon.irmastore.id/logobri.png',
        tipe: 1
      }
    ]
  }),
  mounted () {
    // this.cleardata()
    this.getPaymentmethod()
  },
  computed: {
    ...mapState('SaldoStore', ['paymentmethod', 'tiketdepositresponse', 'overlay', 'loading', 'jmltopup'])
  },
  methods: {
    ...mapActions('SaldoStore', ['getPaymentmethod', 'getTiketDeposit', 'getInvoiceCC', 'cleardata']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    hitungtotal (n) {
      // console.log(n)
      this.totalbayar = this.biaya + this.jmltopup
    },
    selanjutnya () {
      this.$router.push('/confmdeposit')
    },
    doTiketDeposit () {
      if (!this.checkbox) {
        this.$store.dispatch('alert/error', 'mohon centang syarat dan ketentuan')
        return
      }
      var a = {
        jumlah: this.totalbayar,
        methode: this.methode.id,
        methodetext: this.methode.name
      }
      if (this.methode.id === 6) {
        var pdata = {
          amount: parseInt(this.totalbayar)
        }
        this.getInvoiceCC(pdata)
      } else {
        this.getTiketDeposit(a)
      }
    }
  }
}
</script>

<style scoped>
.borderkotak {
  border: thin solid rgba(0,0,0,.12)
}
.boxringkasanbayar {

}
.bulat {
  border-radius: 10px;
}
.panel-syarat {
  list-style-type: none;
  padding-left: 0px;
  max-height: 300px;
  overflow: scroll;
}
</style>
